import React from 'react';

const Callback = () => (
  <div className="container">
    <h4>Loading...</h4>
  </div>
);

export default Callback;